
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Crown } from "lucide-react";

interface UpgradeAlertProps {
  onUpgradeClick: () => void;
}

const UpgradeAlert = ({ onUpgradeClick }: UpgradeAlertProps) => {
  return (
    <Alert>
      <Crown className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span>Upgrade to Pro to access Legal, Aggressive, and Custom tone options.</span>
        <Button 
          size="sm" 
          onClick={onUpgradeClick}
          className="ml-3 bg-gradient-to-r from-brand-primary to-brand-secondary hover:from-brand-primary/90 hover:to-brand-secondary/90"
        >
          <Crown className="w-3 h-3 mr-1" />
          Upgrade
        </Button>
      </AlertDescription>
    </Alert>
  );
};

export default UpgradeAlert;
